import {
  ADDHEALTHDETAILS,
  ADDHEALTHNUMBER,
  ALLHEALTHDETAILS,
  HEALTHNUMFLAG,
  CUST_DETAIL_HEALTH,
  HEALTH_QQ_POST,
  ERROR_QUOTES_HEALTH,
  HEALTH_QUOTE,
  RESET_HEALTH,
  HEALTH_QUESTION,
  CREATE_PROPOSAL_HEALTH,
  KYC_STATUS_HEALTH,
  POLICY_PDF_Health,
} from "../actiontypes/NumHealthActiontypes";
const init = {
  //ishealthno: false,
  cusInfo: {},
  healthnum: "",
  healthmake: "",
  healthmodel: "",
  healthyear: "",
  isallhealthdetails: false,
  famdetail: [],
  QuickQuotePost: {},
  quickquotes: [],
  errquote: [],
  questions: [],
  createProposal: {},
  KycStatus: {},
  policypdf: {},
};
export const numHealthReducer = (state = init, { type, payload }) => {
  switch (type) {
    case CUST_DETAIL_HEALTH:
      return {
        ...state,
        cusInfo: payload,
      };
    case ADDHEALTHNUMBER:
      return {
        ...state,
        healthnum: payload,
        //ishealthno: true
      };
    case HEALTHNUMFLAG:
      return {
        ...state,
        healthnum: "",
        //ishealthno: false
      };
    case ADDHEALTHDETAILS:
      return {
        ...state,
        healthmake: payload.make,
        healthmodel: payload.model,
        healthyear: payload.year,
        isallhealthdetails: true,
      };
    case ALLHEALTHDETAILS:
      return { ...state, famdetail: payload };
    case HEALTH_QQ_POST:
      return { ...state, QuickQuotePost: payload };
    case HEALTH_QUOTE:
      return { ...state, quickquotes: payload };
    case ERROR_QUOTES_HEALTH:
      return { ...state, errquote: payload };
    case HEALTH_QUESTION:
      return { ...state, questions: payload };
    case CREATE_PROPOSAL_HEALTH:
      return { ...state, CreateProposal: payload };
    case KYC_STATUS_HEALTH:
      return { ...state, KycStatus: payload };
    case POLICY_PDF_Health:
      return { ...state, policypdf: payload };
    case RESET_HEALTH:
      return init;
    default:
      return { ...state };
  }
};
